import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Skeleton } from '@comeon/ui';
import { FreeToPlayAppDispatch } from './api/free-to-play-types';
import { fetchSelectedCampaign, onCloseHandler, selectFreeToPlaySelectedCampaignUrl } from './free-to-play-duck';
import useUIContext from '../../ui/use-ui-context';
import styled from 'styled-components';
import Icon, { ICON_CLOSE } from '../icon';
import { CloseButtonSplashtech, CloseButtonThunderbite } from './components/iframe-close-button';
import { SPLASHTECH } from './constants';
import { useParams } from 'react-router-dom';
import { useRouter } from '~/utils/navigation';

const WIDTH = ['100vw', '100vw', '100vw', '80vw'];
const MAX_WIDTH = ['100vw', '100vw', '100vw', '80vw'];
const HEIGHT = ['100%', '100%', '100%', '70vh'];

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	background-color: var(--thunderbite-modal-bg);
	display: flex;
	align-content: center;
	justify-content: center;
	align-items: center;
`;
const Iframe = styled.iframe`
	width: 100%;
	height: 100%;
`;

const FreeToPlayItemDetail = () => {
	const dispatch: FreeToPlayAppDispatch = useDispatch();
	const router = useRouter();
	const params = useParams();
	const campaignId = params.id as string;
	const campaignType = params.type?.toLocaleUpperCase() as string;
	const iFrameUrl = useSelector(selectFreeToPlaySelectedCampaignUrl);
	const uiContext = useUIContext();

	const closeItem = () => {
		dispatch(onCloseHandler());
		router.back();
	};

	useEffect(() => {
		dispatch(fetchSelectedCampaign(campaignId, campaignType));
	}, [dispatch, campaignId, campaignType]);

	return (
		<Wrapper>
			<Box
				width={WIDTH}
				maxWidth={campaignType === SPLASHTECH ? MAX_WIDTH : null}
				height={HEIGHT}
				margin="auto"
				position="relative"
			>
				{iFrameUrl ? <Iframe src={iFrameUrl} /> : <Skeleton />}
				{campaignType === SPLASHTECH ? (
					<CloseButtonSplashtech showSidebar={uiContext.showSidebar} onClick={closeItem}>
						<Icon type={ICON_CLOSE} />
					</CloseButtonSplashtech>
				) : (
					<CloseButtonThunderbite onClick={closeItem}>
						<Icon type={ICON_CLOSE} />
					</CloseButtonThunderbite>
				)}
			</Box>
		</Wrapper>
	);
};

export default FreeToPlayItemDetail;
